
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { showErrorToast } from "@/utils/errorHandling";
import { Job } from '@/types/job'; // Changed to use the global Job type

export const useAvailableJobs = (clientId: string | undefined, existingJobs: Job[] = []) => { // Ensure clientId can be undefined if hook handles it
  return useQuery<Job[], Error>({ // Explicitly type query to use global Job type
    queryKey: ["available-jobs", clientId],
    queryFn: async () => {
      if (!clientId) return []; // Handle undefined clientId gracefully

      try {
        // Get IDs of jobs already linked to this client
        const existingJobIds = existingJobs.map(j => j.id).filter(Boolean);
        
        let query = supabase
          .from("jobs")
          .select("*") // Fetch all columns, ensure they match or are compatible with src/types/job.ts
          .order("title");
          
        if (existingJobIds.length > 0) {
          query = query.not("id", "in", `(${existingJobIds.join(',')})`);
        }
        
        const { data, error } = await query;
        
        if (error) {
          console.error("Error fetching available jobs:", error);
          showErrorToast(error, "Failed to fetch available jobs");
          throw error;
        }
        
        return (data || []) as Job[]; // Cast to the global Job type
      } catch (error) {
        console.error("Error in useAvailableJobs:", error);
        // showErrorToast(error, "Failed to fetch available jobs"); // Already shown if supabase error
        return []; 
      }
    },
    enabled: !!clientId, // Only run query if clientId is available
  });
};
